export const endpoints = {
    settings: {
        get: `/settings`,
    },
    auth: {
        check: `/check`,
        register: `/users`,
        partRegister: `/part-register`,
        forgotPassword: `/forgot-password`,
        setPassword: `/set-password`,
        login: `/login`,
        logout: `/logout`,
        social: `/fb-login`,
        otp: {
            send: `/otp/send`,
            verify: `/otp/verify`,
        }
    },
    portfolio: {
        filters: `/portfolios/filters`,
        search: `/portfolios/search`,
        getById: (id: string) => `/portfolios/${id}`,
        reviews: `/reviews`,
    },
    tasks: {
        filters: `/tasks/available-filters`,
        search: `/tasks/search`,
        getById: (id: string) => `/tasks/${id}`,
        response: (id: string) => `/tasks/${id}/response`,
        changeState: `/tasks/change-status`, // Deprecated
        sendEvent: `/tasks/handle-response-event`,
        delete: (id: string) => `/tasks/${id}`,
        changeResponse: (id: string) => `/responses/${id}`,
    },
    chat: {
        responses: `/responses`,
        client_chats: `/responses/get-customer-responses`,
        master_chats: `/responses/get-master-responses`,
        single_response: (id: string) => `/responses/${id}`,
        actions: (id: string) => `/responses/${id}/actions`,
        messages: (id: string) => `/messages/get-chat-messages/${id}`,
        send_message: `/messages`,
        evaluate: `/reviews`,
        readMessages: `/messages/set-viewed`,
    },
    user: {
        get: `/users/me`,
        updateById: (id: string) => `/users/${id}`,
        delete: (id: string) => `/users/${id}`,
        portfolio: {
            create: `/portfolios`,
            update: (id: string) => `/portfolios/${id}`,
            delete: (id: string) => `/portfolios/${id}`,
        },
        tasks: {
            orders: `/users/orders`,
            list: `/users/tasks`,
            create: `/tasks`,
            suggest: `/tasks/suggest`,
            update: (id: string) => `/tasks/${id}`,
            delete: (id: string) => `/tasks/${id}`,
            review: (id: string) => `/tasks/${id}/review`,
            chat: {
                uploadFile: (id: string) => `/user/tasks/${id}/chat/file`,
                messages: (id: string) => `/user/tasks/${id}/chat/messages`,
            },
            actions: {
                approve: (id: string) => `/user/tasks/${id}/action/approve`,
                callOff: (id: string) => `/user/tasks/${id}/action/call-off`,
                complete: (id: string) => `/user/tasks/${id}/action/complete`,
                resume: (id: string) => `/user/tasks/${id}/action/resume`,
                return: (id: string) => `/user/tasks/${id}/action/return`,
                refuse: (id: string) => `/user/tasks/${id}/action/refuse`,
                submit: (id: string) => `/user/tasks/${id}/action/submit`,
            }
        },
        transactions: `/transactions`,
        unreadMessages: `/messages/get-new-messages-count`,
        recoverPassword: '/recover-password',
        changePassword: '/save-new-password',
        jobtoken: {
            updateWallet: `/users/add-wallet`,
            count: `/users/have-wallet/count`,
            //getTransactions: `/transactions`,
        },
    },
    pages: {
        getById: (id: string) => `/pages/${id}`,
    },
    faq: {
        groups: `/article-groups`,
        singleGroup: (id: string) => `/article-groups/${id}`,
        articles: `/articles`,
        single: (id: string) =>  `/articles/${id}`,
    },
    help: {
        createUnauthTicket: `/support-tickets`,
        getTickets: `/support-tickets`,
        postTickets: `/support-tickets`,
        getSingleTicket: (documentId: string) => `/support-tickets/${documentId}`,
        getMessageFile: (documentId: string, messageId: string, fileId: string) => `/support-tickets/${documentId}/messages/${messageId}/${fileId}`,
        postMessage: (documentId: string) => `/support-tickets/${documentId}/messages`,
        getDisputeByResponse: (documentId: string) => `/task-disputes/${documentId}`,
    },
    files: {
        post: `/upload`,
        delete: (id: string) => `/upload/files/${id}`,
        deleteBulk: `/upload/files`,
    },
    promo: {
        base: 'https://user.yourservice.ae/api',
        register: `/user/register-landing`,
        insta: `/insta-entry`
    },
    payments: {
        feesCalculator: `/responses/fees-calculator`,
        masterConnect: `/transactions/connect`,
        customerGetPaymentLink: (documentId: string) => `/responses/${documentId}/transactions`,
    },
    stories: {
        list: `/stories`,
        getById: (id: string) => `/stories/${id}`,
    },
    paidFeatures: {
        list: `/paid-features`,
        pay: (id: string) => `/paid-features/${id}/purchases`,
    },
    transactions: {
        purchase: `/transactions/connect`,
    },
}